import { render } from "./App.vue?vue&type=template&id=0c83ec06"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0c83ec06&lang=scss"
script.render = render

export default script